// extracted by mini-css-extract-plugin
export default {"homeRedesign":"HomeRedesign_homeRedesign__lt540","mainContent":"HomeRedesign_mainContent__oO7HU","collectionsContainer":"HomeRedesign_collectionsContainer__uszp5"};